import React from "react";
import "../CSS/BlogCardWindow.css";
import { Link } from "react-router-dom";
import DateConverter from '../Utlis/DateConverter'
const BlogCard = (prop) => {
  return (
    <div className="BlogCard">
        <Link className="BlogLink" to={`/blogpage/${prop.ids}`}>
      <div className="image">
        <img src={prop.img} alt="Logo" />
      </div>
      <div className="BlogHead">
        <h3>{prop.title}</h3>
      </div>
      <div className="BlogPara">
        <p>{prop.description}</p>
      </div>
      <div className="Blogfooter">
        <div className="ProfileWrap">
        <p className="profile">
          {prop.author} | {DateConverter(prop.date)} | {prop.sector}
        </p>
        </div>
      </div>
    </Link>
    </div>
  );
};
export default BlogCard;
